/**
 * The two numbers that define a maze's grid, in their own module so that both the thing
 * that builds the maze and the things that place stuff against it can have them.
 *
 * `buildGrounds` re-exports them, which is where the rest of the codebase reads them
 * from. They live here because `buildGrounds` also imports `placeLadders`, and
 * `placeLadders` needs the grid: constants shared across an import cycle are read before
 * the module holding them has finished initialising, and the answer is a silent NaN
 * rather than an error.
 */

/** Grid pitch. With `HEDGE_THICKNESS` off it, a corridor is 2.4 m — four player widths. */
export const CELL_SIZE = 3;
export const HEDGE_THICKNESS = 0.6;
